import styled from '@emotion/styled';

// common
export const Wrapper = styled.div``;

export const Title = styled.div`
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 16px;
  color: ${({ theme }) => theme.colors.neutral[700]};
`;
// Alarm
export const CategoryWrapper = styled.div`
  width: 100%;

  &.sec {
    margin-top: 30px;
  }
`;

export const CategoryTitle = styled.div`
  color: ${({ theme }) => theme.colors.neutral[700]};
  margin-bottom: 16px;
`;

export const CategoryLabel = styled.label<{ disabled?: boolean }>`
  display: flex;
  align-items: center;
  display: flex;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
`;

// Language

// Theme
export const ThemeCard = styled.label`
  display: flex;
  width: 100%;
  flex-direction: column;
  cursor: pointer;
`;

export const ThemeCardTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 34px;
`;

export const BrowserAlarmGuideText = styled.div`
  color: ${({ theme }) => theme.colors.neutral[400]};
  font-size: 12px;
  margin-bottom: 4px;
`;

export const ThemeCardTitle = styled.span`
  color: ${({ theme }) => theme.colors.neutral[700]};
  font-size: 14px;
`;

export const RadioWrapper = styled.div`
  width: 34px;
  height: 34px;
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Radio = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.neutral[700]};
  transition: all 0.2s ease;

  &::after {
    content: '';
    width: 0px;
    height: 0px;
    background-color: ${({ theme }) => theme.colors.neutral[700]};
    border-radius: 4px;
    transition: all 0.2s ease;
  }
`;

export const HiddenInput = styled.input`
  /* visibility: hidden; */
  width: 0px;
  height: 0px;
  position: absolute;
  overflow: hidden;
  left: -9999px;
  top: -9999px;

  /* &:disabled {
        & + ${RadioWrapper} {
            & ${Radio} {
                border: 1px solid ${({ theme }) => theme.colors.shopl[300]};

                &::after {
                    content: '';
                    width: 8px;
                    height: 8px;
                    background-color: ${({ theme }) => theme.colors.shopl[300]};
                }
            }
        }
    } */

  &:checked {
    & + ${RadioWrapper} {
      & ${Radio} {
        border: 1px solid ${({ theme }) => theme.colors.shopl[300]};

        &::after {
          content: '';
          width: 8px;
          height: 8px;
          background-color: ${({ theme }) => theme.colors.shopl[300]};
        }
      }
    }
  }
`;

export const ThemeImgWrapper = styled.div`
  padding-left: 24px;
`;
